import * as R from 'ramda'
import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { initialState, types } from './index'
import { getCurrentPage } from 'utils/interface'

export const fetchSpecialties = ({
  page: customizePage,
  size: customizeSize,
} = {}) => {
  return {
    [RSAA]: {
      endpoint: ({ Doctor }) => {
        const page =
          customizePage !== undefined
            ? customizePage
            : getCurrentPage(Doctor.specialties.page)
        const size =
          customizeSize !== undefined ? customizeSize : Doctor.specialties.size
        return getApiPath('doc', `specialties?page=${page}&size=${size}`, 'v2')
      },
      method: 'GET',
      types: [
        types.FETCH_SPECIALTIES_REQUEST,
        types.FETCH_SPECIALTIES_SUCCESS,
        types.FETCH_SPECIALTIES_ERROR,
      ],
    },
  }
}

export const resetSpecialties = () => ({
  type: types.RESET_SPECIALTIES,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_SPECIALTIES_REQUEST: {
      return {
        ...state,
        specialties: {
          ...state.specialties,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_SPECIALTIES_SUCCESS: {
      const { content = [], page, last } = payload
      return {
        ...state,
        specialties: {
          ...state.specialties,
          page,
          isLastPageReached: last,
          busy: false,
          entities: [...state.specialties.entities, ...content],
        },
      }
    }
    case types.FETCH_SPECIALTIES_ERROR: {
      return {
        ...state,
        specialties: {
          ...state.specialties,
          busy: false,
          error: R.pathOr(
            'Something went wrong',
            ['response', 'message'],
            payload,
          ),
        },
      }
    }

    // ----------

    // this is used when leaving the doctors section so that when the user
    // returns, we don't bombard them with the full list of specialties.
    case types.RESET_SPECIALTIES: {
      return {
        ...state,
        specialties: initialState.specialties,
      }
    }

    default:
      return state
  }
}
